import { Environment } from "src/libs/environment";

const wellbeingEndpoints = {
    authentication:
        "ux-gestion-personas/mep/servicio-al-cliente/v1/api/services/promotik",
    // Not in use
    getSegment:
        "ux-gestion-personas/mep/servicio-al-cliente/v1/api/services/segmentacion",
    validateAccess:
        "ux-consulta-clientes-dacadoo/servicio-al-cliente/mep/v1/clientes/beneficios",
    WebComponent: `${Environment.string(
        "BLOB_STORAGE_URL"
    )}/pacifico-beneficios`,
};

export { wellbeingEndpoints };
